import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const UniversityEdit = () => {
  const [university, setUniversity] = useState({
    universityName: "",
    address: "",
  });

  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory(""); // reset dropdown
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities/${id}`)
      .then((response) => {
        const universityData = response.data || {};
        setUniversity(universityData);
        setCategory(response.data?.category);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL, id]);

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      universityName: university.universityName,
      address: university.address,
      category,
    };

    axios
      .put(`${API_BASE_URL}/universities/${id}`, payload)
      .then((resp) => {
        alert("Data Updated Successfully");
        navigate("/university-all");
      })
      .catch((err) => {
        alert("Error updating university: ", err.message);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUniversity((prevUniversity) => ({
      ...prevUniversity,
      [name]: value,
    }));
  };

  return (
    <div id="add-department-inner-wrapper">
      <div className="course-header-with-btns">
        <h5>Edit University</h5>

        <div className="college-course-nav-btns">
          <Link to="/university-add">
            <button className="college-add-course-add-btn">
              Add University
            </button>
          </Link>
          <Link to="/university-all">
            <button className="college-all-course-btn">All Universities</button>
          </Link>
        </div>
      </div>

      <div className="">
        <div className="form-school-container">
          <h4 className="college-course-detail">University Details</h4>
          <form
            onSubmit={handleEditSubmit}
            className="college-course-detail-form"
          >
            <div className="input-group">
              <label className="label">University Name</label>
              <input
                type="text"
                name="universityName"
                value={university.universityName}
                onChange={handleChange}
                placeholder="Enter University Name..."
                required
              />
            </div>
            <div className="input-group">
              <label className="label">Address</label>
              <input
                type="text"
                name="address"
                value={university.address}
                onChange={handleChange}
                placeholder="Enter University Address..."
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Select Category</label>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <select
                  className="school-class-add-input-tag"
                  value={selectCategory}
                  onChange={(e) => setSelectCategory(e.target.value)}
                >
                  <option value="">-Select Category-</option>
                  <option
                    value="Assignment"
                    // disabled={category.includes("Assignment")}
                  >
                    Assignment
                  </option>
                  <option
                    value="Subjective_Exam"
                    // disabled={category.includes("Subjective_Exam")}
                  >
                    Subjective Exam
                  </option>
                  <option
                    value="Exam_Notes"
                    // disabled={category.includes("Exam_Notes")}
                  >
                    Exam Notes
                  </option>
                  <option
                    value="video_section"
                    // disabled={category.includes("Exam_Notes")}
                  >
                    Video section
                  </option>
                </select>
                <button
                  type="button"
                  onClick={handleAddCategory}
                  className="btn-s"
                >
                  Add
                </button>
              </div>
            </div>

            {/* Show selected categories with remove option */}
            {category.length > 0 && (
              <div className="selected-categories">
                <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
                <ul>
                  {category.map((cat, index) => (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {cat.replaceAll("_", " ")}
                      <button
                        type="button"
                        onClick={() => handleRemoveCategory(cat)}
                        style={{
                          marginLeft: "10px",
                          background: "red",
                          color: "white",
                          border: "none",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="college-course-form-btns">
              <button type="submit" className="btn-search">
                Save
              </button>
              <button
                type="button"
                className="btn-cancel"
                onClick={() => navigate("/university-all")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UniversityEdit;
